import { render, staticRenderFns } from "./removeWatermark.vue?vue&type=template&id=3bb90580&scoped=true"
import script from "./removeWatermark.vue?vue&type=script&lang=js"
export * from "./removeWatermark.vue?vue&type=script&lang=js"
import style0 from "./removeWatermark.vue?vue&type=style&index=0&id=3bb90580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb90580",
  null
  
)

export default component.exports